import type { FaireProductEntity } from "../../entity_types/product";

export const p_u4a8c2dfkq: FaireProductEntity = {
  token: "p_u4a8c2dfkq",
  type: "product",
  name: "Cupcake Bait Birthtday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/da17778310c4631a132b008232d382f9f073a3be57871c3d13439c5e198fd60c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6d2b9ab2aa33588164abfdfaf59c5c9db1b5053795368f45dd0bdb8b46b216e.jpeg",
    "https://cdn.faire.com/fastly/4d925e72b2a57615cbd8ae039e0e25d4b0231227354423dff53fe86bed6904c0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:49.742Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
